import SpriteSymbol from "../../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/_svg-sprite-loader@6.0.9@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "load",
  "use": "load-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"load\"><path d=\"M512 981.312a469.312 469.312 0 10-445.824-322.24A42.688 42.688 0 10147.2 632.32 384 384 0 11512 896a42.688 42.688 0 100 85.312z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id